// extracted by mini-css-extract-plugin
export default {"container":"forgotPassword_container__lMetj","cardContainer":"forgotPassword_cardContainer__mjWoR","innerContainer":"forgotPassword_innerContainer__phLA6"};